import { Component } from '@angular/core';
import { SparePartService } from 'src/app/services/spare-parts/spare-part.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-spare-parts-list',
  templateUrl: './spare-parts-list.component.html',
  styleUrls: ['./spare-parts-list.component.css']
})
export class SparePartsListComponent {
  page: number = 1;
  count: number = 0;
  searchText: string = '';
  spart_parts: any[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public isProcessing: boolean = false;

  constructor(
    private sparePartService: SparePartService
  ){}

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll():void{
    this.sparePartService.getAll().subscribe((response: ApiResponse) =>this.spart_parts = response.data);
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.fetchAll();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  deleteSparePart(event: Event,partId:string){
    event.preventDefault();
    this.confirmBox(partId);
  }

  confirmBox(partId: string){
    Swal.fire({
      title: 'Confirm Delete',
      text: 'Are you sure you want to delete this record? The action is irreversible!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.isProcessing=true;

        this.sparePartService.delete(partId)
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.isProcessing=false;
              this.successMessage=response.message;
              this.errorMessage=''; //Clear error message incase it's available
             
              //Reload spare parts
              this.fetchAll();
            }else if(response.status==='error'){
              this.isProcessing=false;
              this.errorMessage=response.message;
            }else{
              this.isProcessing=false;
              this.errorMessage=response.message;
            }
          },
          error: (error) => {
            this.isProcessing=false;
            this.errorMessage=error;
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      
      }
    })
  }

}
